import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { FacilitiesService } from './facilities.service';

@Component({
    selector: 'app-update-facilities',
    templateUrl: './update-facilities.component.html',
    styleUrls: ['./update-facilities.component.css'],
    standalone: false
})
export class UpdateFacilitiesComponent implements OnInit {

  public currentOrganizationId: number;
  public currentOrganizationType: number;
  public formGroup: FormGroup;

  private _organization: Organization;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _facilitiesService: FacilitiesService,
    private _formBuilder: FormBuilder, private _sharedService: SharedService, private _toastService: ToastService) {
    this.formGroup = this._formBuilder.group({
      'hasShop': [0],
      'hasParking': [0],
      'hasHandicapFriendly': [0],
      /*facilities only for museum*/
      'hasFamilyFriendly': [0],
      'hasMobileCard': [0],
      'hasBar': [0],
      'hasAudioGuide': [0],
      'hasSchoolOffers': [0],
       /*facilities only for lido*/
      'hasChildFriendlySwimmingPool': [0],
      'hasDogsAllowed': [0],
      'hasGastronomicOffer': [0],
      'hasHeatedPool': [0],
      'hasVolley': [0],
      'hasChildrensPlayground': [0],
      'hasSwimLanes': [0],
      'hasLoungerUmbrellaHire': [0],
      'hasLifeguard': [0],
      'hasPedalBoatHire': [0],
      'hasWaterSlide': [0]
    });

    this._toastService.remove();
  }

  ngOnInit(): void {
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['/']);
    }
    // tslint:disable-next-line:radix
    /* Ivan
    if (parseInt(localStorage.getItem('orgId')) !== 2) {
      this._router.navigate(['/']);
    }
    */
    this.currentOrganizationId = urlPramas.orgId;
    this.currentOrganizationType = parseInt(localStorage.getItem('orgId'), 5);
    // console.log(this.currentOrganizationType);
    this._sharedService.getOrganization(urlPramas.orgId).subscribe(requestResult => {
      this._organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this._organization.name_de, 'it': this._organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this._facilitiesService.getOrganizationFacilities(this.currentOrganizationId.toString()).subscribe(result => {
      // console.log(result);
      this.formGroup.setValue(result);
    });
  }

  onFormSubmit() {
    this._facilitiesService.updateFacilities(this.currentOrganizationId.toString(), this.formGroup.value).subscribe(result => {
      this._toastService.show('', {
        classname: 'bg-success text-light',
        delay: 2000,
        autohide: true,
      });
    }, requestError => {
      console.log('Error');
    });
  }

}
